// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"94d1890d","440":"2ec61091","494":"19fa4d71","523":"8024e6de","528":"460f2262","576":"7822101b","585":"e48059b2","647":"44aafb27","923":"7bd3e898"}[chunkId] + ".chunk.js";
};